<template>
  <b-row>
    <b-col xl="12" lg="12">
      <Widget>
        <b-row>
          <b-col md="6" style="height: 30px">
            <h4>Berita Acara</h4>
          </b-col>
          <b-col md="6" style="height: 30px">
            <div style="float: right">
              <b-button v-if="dataPermohonan.catatan_ba_direktur != null" variant="outline-primary"
                v-b-modal.modal-catatan>
                <main rel="main">
                  <div class="notification">
                    <svg viewbox="-10 0 60 60" width="60" height="60">
                      <path class="notification--bell"
                        d="M14 12v1H0v-1l0.73-0.58c0.77-0.77 0.81-3.55 1.19-4.42 0.77-3.77 4.08-5 4.08-5 0-0.55 0.45-1 1-1s1 0.45 1 1c0 0 3.39 1.23 4.16 5 0.38 1.88 0.42 3.66 1.19 4.42l0.66 0.58z">
                      </path>
                      <path class="notification--bellClapper" d="M7 15.7c1.11 0 2-0.89 2-2H5c0 1.11 0.89 2 2 2z"></path>
                    </svg>
                  </div>
                </main> <span style="margin-left:20px">Catatan</span>
              </b-button>

            </div>
          </b-col>
        </b-row>

        <form-wizard shape="tab" color="#3498db" title="" subtitle="" @on-change="updateProgress"
          @on-loading="updateProgress(1, 1)">
          <b-progress class="progress-xs" variant="info" :value="progress" :max="2" />
          <b-button slot="prev" variant="primary" id="back" hidden class="text-white">
            <i class="fa fa-caret-left" /> Sebelumnya
          </b-button>
          <b-button slot="next" variant="primary" id="next" hidden class="text-white">
            Selanjutnya <i class="fa fa-caret-right" />
          </b-button>
          <b-button @click="$router.push('/app/penambahan-kbli')" slot="finish" variant="success" id="finish" hidden
            class="text-white">
            Selesai <i class="fa fa-check" />
          </b-button>
          <tab-content title="1. Profil">
            <Profil @nextDokumen="nextDokumen" :dataPermohonan="dataPermohonan" :dataKBLI="dataKBLI"
              :dataKlasifikasi="dataKlasifikasi"></Profil>

            <!-- <div class="row justify-content-between">
              <div class="col-4">
                <div class="text-left">
                  <b-button @click="$router.push('/app/penambahan-kbli')" variant="danger">Back</b-button>
                </div>
              </div>
              <div class="col-4">
                <div class="text-right">
                  <b-button @click="simpanProfil()" style="float: right" variant="primary">Next <i
                      class="fa fa-caret-right" />
                  </b-button>
                </div>
              </div>
            </div> -->
          </tab-content>
          <tab-content title="2. Hasil Penilaian Teknis" style="background-color: white !important;">
            <form ref="form" @submit.stop.prevent="tambahdata" data-vv-scope="form-5">
              <legend><strong>Hasil Penilaian Teknis</strong></legend>
              <!-- <b-row>
                        <div class="col-12">
                            Ditetapkan dalam Peraturan Daerah
                        </div>
                    </b-row> -->
              <!-- <b-row>
                        <div class="col-md-3">
                            <b-form-group label="Provinsi *">
                                <v-select
                                    
                                    id="default-select"
                                    v-model="dataPermohonan.provinsi"
                                    :reduce="provinsi => provinsi.nama_provinsi"
                                    label="nama_provinsi"
                                    :options="dataProvinsi"
                                    v-validate="'required'" name="Provinsi"
                                    :class="{ 'is-invalid': errors.has('form-5.Provinsi') }"
                                    @change="getKabupaten(dataPermohonan.provinsi)"
                                />
                                <span class="text-danger" v-if="errors.has('form-5.Provinsi')">
                                    {{ errors.first('form-5.Provinsi') }}
                                </span>
                            </b-form-group>
                        </div>
                        <div class="col-md-3">
                            <b-form-group label="Kabupaten *">
                                <v-select
                                    
                                    id="default-select"
                                    v-model="dataPermohonan.kabupaten"
                                    :reduce="kabupaten => kabupaten.nama_kabupaten"
                                    label="nama_kabupaten"
                                    :options="dataKabupaten"
                                    v-validate="'required'" name="Kabupaten"
                                    :class="{ 'is-invalid': errors.has('form-5.Kabupaten') }"
                                    @change="getKecamatan(dataPermohonan.kabupaten)"
                                />
                                <span class="text-danger" v-if="errors.has('form-5.Kabupaten')">
                                    {{ errors.first('form-5.Kabupaten') }}
                                </span>
                            </b-form-group>
                        </div>
                        <div class="col-md-3">
                            <b-form-group label="Kecamatan *">
                                <v-select
                                    
                                    id="default-select"
                                    v-model="dataPermohonan.kecamatan"
                                    :reduce="kecamatan => kecamatan.nama_kecamatan"
                                    label="nama_kecamatan"
                                    :options="dataKecamatan"
                                    v-validate="'required'" name="Kecamatan"
                                    :class="{ 'is-invalid': errors.has('form-5.Kecamatan') }"
                                />
                                <span class="text-danger" v-if="errors.has('form-5.Kecamatan')">
                                    {{ errors.first('form-5.Kecamatan') }}
                                </span>
                            </b-form-group>
                        </div>
                        <div class="col-md-3">
                            <b-form-group label="Nomor *">
                                <b-form-input  v-validate="'required'" placeholder="Nomor Perda" name="Nomor Perda"
                                :class="{ 'form-control': true, 'is-invalid': errors.has('form-5.Nomor Perda') }" id="name" type="text" v-model="dataPermohonan.nomor_perda" />
                                <span class="text-danger" v-if="errors.has('form-5.Nomor Perda')">
                                    {{ errors.first('form-5.Nomor Perda') }}
                                </span>
                            </b-form-group>
                        </div>
                        <div class="col-md-3">
                            <b-form-group label="Tahun *">
                                <b-form-input  v-validate="'required'" placeholder="Tahun Perda" name="Tahun Perda"
                                :class="{ 'form-control': true, 'is-invalid': errors.has('form-5.Tahun Perda') }" id="name" type="text" v-model="dataPermohonan.tahun_perda" />
                                <span class="text-danger" v-if="errors.has('form-5.Tahun Perda')">
                                    {{ errors.first('form-5.Tahun Perda') }}
                                </span>
                            </b-form-group>
                        </div>
                        <div class="col-md-3">
                            <b-form-group label="Tentang *">
                                <b-form-input  v-validate="'required'" placeholder="Tentang Perda" name="Tentang Perda"
                                :class="{ 'form-control': true, 'is-invalid': errors.has('form-5.Tentang Perda') }" id="name" type="text" v-model="dataPermohonan.tentang_perda" />
                                <span class="text-danger" v-if="errors.has('form-5.Tentang Perda')">
                                    {{ errors.first('form-5.Tentang Perda') }}
                                </span>
                            </b-form-group>
                        </div>
                        <div class="col-md-3">
                            <b-form-group label="Kedalaman *">
                                <b-form-input  v-validate="'required'" name="Kedalaman" min="0" step=".01" type="number"
                                :class="{ 'form-control': true, 'is-invalid': errors.has('form-5.Kedalaman') }" id="name" v-model="dataPermohonan.kedalaman" />
                                <span class="text-danger" v-if="errors.has('form-5.Kedalaman')">
                                    {{ errors.first('form-5.Kedalaman') }}
                                </span>
                            </b-form-group>
                        </div>
                    </b-row>
                    <b-row>
                        <div class="col-12">
                            Kesesuaian Tata Ruang
                        </div>
                    </b-row>
                    <b-row>
                        <div class="col-md-3">
                            <b-form-group label="Nama Perairan *">
                                <b-form-input  v-validate="'required'" name="Kawasan"
                                :class="{ 'form-control': true, 'is-invalid': errors.has('form-5.Nama Perairan') }" id="name" type="text" v-model="dataPermohonan.nama_perairan" />
                                <span class="text-danger" v-if="errors.has('form-5.Nama Perairan')">
                                    {{ errors.first('form-5.Nama Perairan') }}
                                </span>
                            </b-form-group>
                        </div>
                        <div class="col-md-3">
                            <b-form-group label="Kawasan *">
                                <b-form-input  v-validate="'required'" name="Kawasan"
                                :class="{ 'form-control': true, 'is-invalid': errors.has('form-5.Kawasan') }" id="name" type="text" v-model="dataPermohonan.kawasan" />
                                <span class="text-danger" v-if="errors.has('form-5.Kawasan')">
                                    {{ errors.first('form-5.Kawasan') }}
                                </span>
                            </b-form-group>
                        </div>
                        <div class="col-md-3">
                            <b-form-group label="Zona *">
                                <b-form-input  v-validate="'required'" name="Zona"
                                :class="{ 'form-control': true, 'is-invalid': errors.has('form-5.Zona') }" id="name" type="text" v-model="dataPermohonan.zona" />
                                <span class="text-danger" v-if="errors.has('form-5.Zona')">
                                    {{ errors.first('form-5.Zona') }}
                                </span>
                            </b-form-group>
                        </div>
                        <div class="col-md-3">
                            <b-form-group label="Subzona *">
                                <b-form-input  v-validate="'required'" name="Subzona"
                                :class="{ 'form-control': true, 'is-invalid': errors.has('form-5.Subzona') }" id="name" type="text" v-model="dataPermohonan.subzona" />
                                <span class="text-danger" v-if="errors.has('form-5.Subzona')">
                                    {{ errors.first('form-5.Subzona') }}
                                </span>
                            </b-form-group>
                        </div>
                    </b-row> -->
              <!-- <b-row>
                        <div class="col-12">
                            Hasil Rekomendasi
                        </div>
                    </b-row> -->
              <b-row>
                <div class="col-md-3">
                  <b-form-group label="Hasil Penilaian Teknis*" label-for="Hasil Penilaian Teknis">
                    <v-select id="default-select" v-model="dataPermohonan.hasil_vertek"
                      :options="['Setuju', 'Setuju dengan catatan', 'Ditolak']" v-validate="'required'"
                      name="Hasil Penilaian Teknis" :class="{
                        'is-invalid': errors.has(
                          'form-5.Hasil Penilaian Teknis'
                        ),
                      }" />
                    <span class="text-danger" v-if="errors.has('form-5.Hasil Penilaian Teknis')">
                      {{ errors.first("form-5.Hasil Penilaian Teknis") }}
                    </span>
                  </b-form-group>
                </div>
                <!-- <b-col md="3">
                  <b-form-group label-for="Form" label="PNBP: *">
                    <b-form-select v-model="dataPermohonan.perlu_pnbp" v-validate="'required'" name="PNBP"
                      :class="{ 'is-invalid': errors.has('form-5.Perlu PNBP') }" :options="optionsPerluPNBP"></b-form-select>
                    <span class="text-danger" v-if="errors.has('form-5.PNBP')">
                      {{ errors.first("form-5.PNBP") }}
                    </span>
                  </b-form-group>
                </b-col> -->
              </b-row>

              <legend><strong>Izin Terbit</strong></legend>
              <b-row>
                <b-col md="4">
                  <b-form-group label="Nomor Izin Terbit: *" label-for="username">
                    <b-form-input v-validate="'required'" name="Nomor Izin Terbit" :class="{
                      'form-control': true,
                      'is-invalid': errors.has('form-5.Nomor Izin Terbit'),
                    }" id="name" type="text" v-model="dataPermohonan.nomor_izin_terbit" @input="checkIzinTerbit" />
                    <span class="text-danger" v-if="errors.has('form-5.Nomor Izin Terbit')">
                      {{ errors.first("form-5.Nomor Izin Terbit") }}
                    </span>
                    <span class="text-success"
                      v-if="!status_nomor_oss_error && nomor_oss_checked && dataPermohonan.nomor_izin_terbit != ''">
                      ✔ Nomor Izin Terbit ditemukan
                    </span>

                    <span class="text-danger" v-if="status_nomor_oss_error && dataPermohonan.nomor_izin_terbit != ''">
                      ✖ Nomor Izin Terbit tidak ditemukan, silahkan cek kembali
                    </span>
                  </b-form-group>
                </b-col>
              </b-row>

              <legend><strong>Tanda Tangan</strong></legend>
              <b-row>
                <div class="col-md-4">
                  <b-form-group label="Direktur" label-for="Direktur">
                    <v-select id="default-select" v-model="dataPermohonan.ttd_ba_vertek_1"
                      :reduce="(user) => user.id_user" label="nama_lengkap" :options="dataTTDDirektur"
                      v-validate="'required'" name="Direktur"
                      :class="{ 'is-invalid': errors.has('form-5.Direktur') }" />
                    <span class="text-danger" v-if="errors.has('form-5.Direktur')">
                      {{ errors.first("form-5.Direktur") }}
                    </span>
                  </b-form-group>
                </div>
                <div class="col-md-4">
                  <b-form-group label="Ketua Tim" label-for="Ketua Tim">
                    <v-select id="default-select" v-model="dataPermohonan.ttd_ba_vertek_2" label="nama_lengkap"
                      :reduce="(user) => user.id_user" :options="dataTTDKetuaTIM" v-validate="'required'"
                      name="Ketua Tim" :class="{ 'is-invalid': errors.has('form-5.Ketua Tim') }" />
                    <span class="text-danger" v-if="errors.has('form-5.Ketua Tim')">
                      {{ errors.first("form-5.Ketua Tim") }}
                    </span>
                  </b-form-group>
                </div>
                <!-- <div class="col-md-3">
                  <b-form-group label="Ketua Tim" label-for="Ketua Tim">
                    <v-select id="default-select" v-model="dataPermohonan.ttd_ba_vertek_3" label="nama_lengkap"
                      :reduce="(user) => user.id_user" :options="dataTtd" v-validate="'required'" name="Ketua Tim"
                      :class="{ 'is-invalid': errors.has('form-5.Ketua Tim') }" />
                    <span class="text-danger" v-if="errors.has('form-5.Ketua Tim')">
                      {{ errors.first("form-5.Ketua Tim") }}
                    </span>
                  </b-form-group>
                </div> -->
                <div class="col-md-4">
                  <b-form-group label="Pimpinan Rapat" label-for="Pimpinan Rapat">
                    <v-select id="default-select" v-model="dataPermohonan.ttd_ba_vertek_4" label="nama_lengkap"
                      :reduce="(user) => user.id_user" :options="dataTTDPimpinanRapat" v-validate="'required'"
                      name="Pimpinan Rapat" :class="{
                        'is-invalid': errors.has('form-5.Pimpinan Rapat'),
                      }" />
                    <span class="text-danger" v-if="errors.has('form-5.Pimpinan Rapat')">
                      {{ errors.first("form-5.Pimpinan Rapat") }}
                    </span>
                  </b-form-group>
                </div>
                <!-- <div class="col-md-3">
                            <b-form-group label="Subkoordinator">
                                <v-select
                                    
                                    id="default-select"
                                    v-model="dataPermohonan.ttd_ba_vertek_5"
                                    label="nama_lengkap"
                                    :reduce="user => user.id_user"
                                    :options="dataTtd"
                                />
                            </b-form-group>
                        </div> -->
                <!-- <div class="col-md-3">
                            <b-form-group label="Pimpinan Rapat">
                                <v-select
                                    
                                    id="default-select"
                                    v-model="dataPermohonan.pimpinan_rapat"
                                    :reduce="user => user.value"
                                    label="text"
                                    :options="dataPimpinan" v-validate="'required'" name="Pimpinan Rapat"
                                    :class="{ 'is-invalid': errors.has('form-5.Pimpinan Rapat') }"
                                />
                                <span class="text-danger" v-if="errors.has('form-5.Pimpinan Rapat')">
                                    {{ errors.first('form-5.Pimpinan Rapat') }}
                                </span>
                            </b-form-group>
                        </div> -->
              </b-row>

              <legend><strong>Koordinat</strong></legend>
              <div class="row mb-md-2">
                <div class="col-sm-12 col-md-6">
                  <b-button variant="success" v-b-modal.modal-tambah-kordinat><span
                      class="glyphicon glyphicon-plus mb-2" /> Tambah
                  </b-button>
                  <b-button variant="primary" style="margin-left: 5px" data-toggle="modal" data-target=".import"><i
                      class="fa fa-file-excel-o" aria-hidden="true" />
                    Import</b-button>&nbsp;
                  <b-button v-if="dataKordinat.length > 0" variant="danger" class="text-white" style="margin-left: 5px"
                    @click="hapusSemuaKordinat"><i class="fa fa-trash" aria-hidden="true" />
                    Hapus Semua</b-button>&nbsp;
                </div>
                <div class="col-sm-12 col-md-6">
                  <div id="tickets-table_filter" class="dataTables_filter text-md-end">
                    <label class="d-inline-flex align-items-center">
                      <b-form-input v-model="filter" type="search" placeholder="Search..."
                        class="form-control form-control-sm ml-2"></b-form-input>
                    </label>
                  </div>
                </div>
              </div>
              <div class="table-responsive mb-0 datatables">
                <b-table striped hover :items="itemsWithNumber" :fields="fields" responsive="sm" :per-page="perPage"
                  :current-page="currentPage" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :filter="filter"
                  :filter-included-fields="filterOn" @filtered="onFiltered">
                  <template #cell(aksi)="data">
                    <b-button variant="info" class="me-3" size="s" @click="getDetailKordinat(data.item.id)">
                      <i class="glyphicon glyphicon-pencil text-white me-sm-1 mb-sm-2" />
                      <span class="d-none d-md-inline-block text-white">
                        Edit</span>
                    </b-button>
                    <b-button style="margin-left: 5px" variant="danger" class="me-3" size="s"
                      @click="deleteData(data.item.id)">
                      <i class="glyphicon glyphicon-trash text-white me-sm-1 mb-sm-2" />
                      <span class="d-none d-md-inline-block text-white">
                        Hapus</span>
                    </b-button>
                  </template>
                  <template #cell(tanggal_pada_permohonan)="data">
                    {{ format_date(data.item.tanggal_pada_permohonan) }}
                  </template>
                </b-table>
              </div>
              <div class="row mb-md-2">
                <div class="col-sm-12 col-md-6">
                  <div id="tickets-table_length" class="dataTables_length">
                    <label class="d-inline-flex align-items-center">
                      <b-form-select class="form-control form-control-sm form-select form-select-sm" v-model="perPage"
                        size="sm" :options="pageOptions"></b-form-select>
                    </label>
                  </div>
                </div>
                <div class="col-sm-12 col-md-6"></div>
              </div>
              <div class="row">
                <div class="col">
                  <div class="dataTables_paginate paging_simple_numbers float-end">
                    <ul class="pagination pagination-rounded mb-0">
                      <b-pagination first-text="First" prev-text="Prev" next-text="Next" last-text="Last"
                        v-model="currentPage" :total-rows="rows" :per-page="perPage"></b-pagination>
                    </ul>
                  </div>
                </div>
              </div>
              <legend><strong>Upload File Lampiran</strong></legend>
              <div class="row mb-3">
                <b-col md="6">
                  <b-form-group label="File Lampiran Peta: " label-for="username">
                    <b-form-file ref="filelampiran" class="d-none" v-model="file_lampiran" accept="image/*"
                      @input="handleFiles"></b-form-file>
                    <!-- <b-form-file  ref="filelampiran" class="d-none"placeholder="Choose a file image or drop it here..."
                      drop-placeholder="Drop file here..." plain  @input="handleFiles"
                      accept="image/*"></b-form-file> -->
                    <b-button variant="secondary" @click="$refs.filelampiran.$el.querySelector('input').click()"
                      class="text-white" size="sm">
                      <i class="fa fa-upload"></i> Unggah File
                    </b-button>

                    <!-- <b-form-file placeholder="Choose a file image or drop it here..."
                      drop-placeholder="Drop file here..." plain class="form-control" @change="handleFiles"
                      v-validate="'required|image'" name="File Lampiran Peta" multiple accept="image/*" :class="{
                        'is-invalid': errors.has('form-5.File Lampiran Peta'),
                      }"></b-form-file> -->

                    <!-- <span class="text-danger" v-if="errors.has('form-5.File Lampiran Peta')">
                      {{ errors.first("form-5.File Lampiran Peta") }}
                    </span> -->

                  </b-form-group>
                  <ul class="list-group" v-if="dataPermohonan.file_lampiran_ba.length != 0">
                    <li v-for="(file, index) in dataPermohonan.file_lampiran_ba" :key="index"
                      class="list-group-item d-flex align-items-center justify-content-between">
                      <!-- nomor -->
                      <div class="me-3 fw-bold" style="width: 30px;">
                        {{ index + 1 }}.
                      </div>

                      <!-- nama file -->
                      <div class="flex-grow-1 text-truncate">
                        {{ file ? file.split('/').pop() : '' }}
                      </div>

                      <!-- tombol aksi -->
                      <div class="d-flex gap-2">
                        <button class="btn btn-sm btn-danger text-white" @click="hapusFile(file)">
                          <i class="glyphicon glyphicon-trash pb-2"></i>
                        </button>
                        <a :href="file" class="btn btn-sm btn-primary text-white" target="_blank">
                          <i class="glyphicon glyphicon-download pb-2"></i>
                        </a>
                      </div>
                    </li>

                  </ul>
                  <template v-else>
                    <span>Tidak ada lampiran!</span>
                  </template>

                  <!-- <b-button v-if="
                    dataPermohonan.file_lampiran_ba != null &&
                    isValidUrl(dataPermohonan.file_lampiran_ba)
                  " :href="dataPermohonan.file_lampiran_ba" target="_blank"><i
                      class="glyphicon glyphicon-download text-white me-sm-1 mb-sm-2"></i>Download File Lampiran
                    BA</b-button> -->
                </b-col>
                <b-col md="6">
                  <b-form-group label="File Lampiran Tambahan: " label-for="username">
                    <b-form-file placeholder="Choose a file or drop it here..." drop-placeholder="Drop file here..."
                      plain class="form-control" v-model="dataPermohonan.file_lampiran_tambahan"
                      accept=".pdf"></b-form-file>
                  </b-form-group>

                  <b-button v-if="
                    dataPermohonan.file_lampiran_tambahan != null &&
                    isValidUrl(dataPermohonan.file_lampiran_tambahan)
                  " :href="dataPermohonan.file_lampiran_tambahan" target="_blank"><i
                      class="glyphicon glyphicon-download text-white me-sm-1 mb-sm-2"></i>Download File Lampiran
                    Tambahan</b-button>
                </b-col>
              </div>

              <template v-if="dataPermohonan.hasil_vertek === 'Ditolak'">
                <legend><strong>Penolakan Hasil Penilaian Teknis</strong></legend>

                <div class="row">
                  <b-col md="12">
                    <div class="form-group mt-2">
                      <b-form-group label="Alasan Penolakan: *">
                        <ckeditor :editor="wygEditor" v-model="dataPermohonan.alasan_penolakan"></ckeditor>
                      </b-form-group>
                    </div>
                  </b-col>
                </div>
              </template>
            </form>
            <div class="row justify-content-between">
              <div class="col-4">
                <div class="text-left">
                  <b-button @click="previousDokumen()" variant="primary"><i class="fa fa-caret-left" />
                    Sebelumnya</b-button>
                </div>
              </div>
              <div class="col-4">
                <div class="text-right">
                  <b-button @click="hasilVerif()" style="float: right" variant="success">Selesai <i
                      class="fa fa-check" /></b-button>
                </div>
              </div>
            </div>
          </tab-content>
        </form-wizard>
      </Widget>
    </b-col>

    <b-modal body-class="bg-white" id="modal-tambah-kordinat" scrollable title="Tambah Data Kordinat"
      cancel-title="Close" ok-title="Accept" cancel-variant="outline-secondary">
      <form ref="form" @submit.stop.prevent="tambahdata" data-vv-scope="form-2">
        <b-form-group label="Nama" label-for="name" class="mb-3">
          <b-form-input v-validate="'required'" name="nama" :class="{
            'form-control': true,
            'is-invalid': errors.has('form-2.nama'),
          }" id="name" v-model="detailKordinat.nama_titik" />
          <span class="text-danger" v-if="errors.has('form-2.nama')">
            {{ errors.first("form-2.nama") }}
          </span>
        </b-form-group>

        <b-form-group label="Bujur" label-for="name" class="mb-3">
          <b-form-input v-validate="'required'" name="Bujur" :class="{
            'form-control': true,
            'is-invalid': errors.has('form-2.Bujur'),
          }" id="name" v-model="detailKordinat.bujur" />
          <span class="text-danger" v-if="errors.has('form-2.Bujur')">
            {{ errors.first("form-2.Bujur") }}
          </span>
        </b-form-group>

        <b-form-group label="Lintang" label-for="name" class="mb-3">
          <b-form-input v-validate="'required'" name="Lintang" :class="{
            'form-control': true,
            'is-invalid': errors.has('form-2.Lintang'),
          }" id="name" v-model="detailKordinat.lintang" />
          <span class="text-danger" v-if="errors.has('form-2.Lintang')">
            {{ errors.first("form-2.Lintang") }}
          </span>
        </b-form-group>
      </form>

      <template #modal-footer>
        <div class="w-100">
          <b-button variant="primary" style="float: right" @click="simpanKordinat">
            <i class="fa fa-floppy-o text-white" />
            <span class="text-white"> Simpan</span>
          </b-button>
        </div>
      </template>
    </b-modal>

    <b-modal body-class="bg-white" id="modal-detail-kordinat" scrollable title="Ubah Data Kordinat" cancel-title="Close"
      ok-title="Accept" cancel-variant="outline-secondary">
      <form ref="form" @submit.stop.prevent="tambahdata" data-vv-scope="form-2">
        <b-form-group label="Nama" label-for="name" class="mb-3">
          <b-form-input v-validate="'required'" name="nama" :class="{
            'form-control': true,
            'is-invalid': errors.has('form-2.nama'),
          }" id="name" v-model="detailKordinat.nama_titik" />
          <span class="text-danger" v-if="errors.has('form-2.nama')">
            {{ errors.first("form-2.nama") }}
          </span>
        </b-form-group>

        <b-form-group label="Bujur" label-for="name" class="mb-3">
          <b-form-input v-validate="'required'" name="Bujur" :class="{
            'form-control': true,
            'is-invalid': errors.has('form-2.Bujur'),
          }" id="name" v-model="detailKordinat.bujur" />
          <span class="text-danger" v-if="errors.has('form-2.Bujur')">
            {{ errors.first("form-2.Bujur") }}
          </span>
        </b-form-group>

        <b-form-group label="Lintang" label-for="name" class="mb-3">
          <b-form-input v-validate="'required'" name="Lintang" :class="{
            'form-control': true,
            'is-invalid': errors.has('form-2.Lintang'),
          }" id="name" v-model="detailKordinat.lintang" />
          <span class="text-danger" v-if="errors.has('form-2.Lintang')">
            {{ errors.first("form-2.Lintang") }}
          </span>
        </b-form-group>
      </form>

      <template #modal-footer>
        <div class="w-100">
          <b-button variant="primary" style="float: right" @click="editKordinat">
            <i class="fa fa-floppy-o text-white" />
            <span class="text-white"> Simpan</span>
          </b-button>
        </div>
      </template>
    </b-modal>

    <!-- import excel kordinat -->
    <div class="modal fade import" tabindex="-1" id="import" role="dialog" aria-labelledby="myLargeModalLabel"
      aria-hidden="true">
      <div class="modal-dialog modal-md">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Import</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body" style="background-color: white">
            <b-card title="Template Excel">
              <b-card-text>
                Silahkan download template excel berikut sebelum melakukan
                import
              </b-card-text>
              <b-button href="https://doc-sea.kkp.go.id/dokumen/format_import_kordinat.xlsx" variant="primary"><i
                  class="fa fa-download" aria-hidden="true" /> Download
              </b-button>
            </b-card>

            <div>
              <br />
              <form ref="form" @submit.stop.prevent="mportexcel" data-vv-scope="form-1">
                <div class="col-md-12">
                  <b-form-group label="File">
                    <b-form-file placeholder="Choose a file or drop it here..." drop-placeholder="Drop file here..."
                      plain class="form-control" v-model="detailKordinat.file" accept=".xlsx" v-validate="'required'"
                      name="file" :class="{ 'is-invalid': errors.has('form-1.file') }"></b-form-file>
                    <span class="text-danger" v-if="errors.has('form-1.file')">
                      {{ errors.first("form-1.file") }}
                    </span>
                  </b-form-group>
                </div>
              </form>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">
              Close
            </button>
            <b-button @click="importexcel" variant="primary" data-dismiss="modal"><i
                class="fa fa-floppy-o text-white" />
              Simpan
            </b-button>
          </div>
        </div>
      </div>
    </div>

    <b-modal id="modal-catatan" size="lg" body-class="bg-white" title="Catatan Direktur" ok-only
      cancel-variant="default">
      <div v-html="dataPermohonan.catatan_ba_direktur"></div>
    </b-modal>
  </b-row>
</template>

<script>
import Vue from "vue";
import vSelect from "vue-select";
import Widget from "@/components/Widget/Widget";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import axios from "axios";
import DatePicker from "vue2-datepicker";
import Swal from "sweetalert2";
import VueLoading from "vuejs-loading-plugin";
import Profil from "../Detail/Profil/Profil.vue";

// using default options
Vue.use(VueLoading);

// overwrite defaults
Vue.use(VueLoading, {
  dark: true, // default false
  text: "Loading", // default 'Loading'
  loading: true, // default false
  //customLoader: myVueComponent, // replaces the spinner and text with your own
  background: "rgb(255,255,255)", // set custom background
  classes: ["myclass"], // array, object or string
});

//   import { select2CountriesData, select2ShipmentData, cardTypesData } from './data';

export default {
  name: "FormWizardPage",
  components: { Widget, vSelect, ClassicEditor, DatePicker, Profil },
  data() {
    return {
      baseapi: localStorage.getItem("baseapi"),
      user: JSON.parse(localStorage.getItem("user")),
      progress: 1,
      dataJenisProyek: [],
      dataRisiko: [],
      dataSkalaUsaha: [],
      dataStatusVerdok: [],
      dataPerDokumen: [],
      dataPermohonan: [],
      radioOne: 0,
      wygEditor: ClassicEditor,

      columnsDatatable: ["no", "nama_titik", "bujur", "lintang", "aksi"],
      dataUser: [],
      dataRoles: [],
      optionsKordinat: {
        perPage: 10,
        pagination: { chunk: 10, dropdown: false },
        texts: { filter: "", count: "", limit: "" },
        columnsClasses: { no: "width-100" },
        skin: "table table-striped",
        sortIcon: {
          base: "fa text-muted",
          up: "fa-chevron-up",
          down: "fa-chevron-down",
          is: "fa-sort",
        },
      },
      dataKordinat: [],
      dataPenandatangan: [],
      columnsPenandatangan: [
        "no",
        "nama",
        "NIP",
        "jabatan",
        "kedudukan",
        "aksi",
      ],
      optionsPenandatangan: {
        perPage: 10,
        pagination: { chunk: 10, dropdown: false },
        texts: { filter: "", count: "", limit: "" },
        columnsClasses: { no: "width-100" },
        skin: "table table-striped",
        sortIcon: {
          base: "fa text-muted",
          up: "fa-chevron-up",
          down: "fa-chevron-down",
          is: "fa-sort",
        },
      },
      detailKordinat: [],

      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: "name",
      sortDesc: false,
      fields: [
        "no",
        { key: "nama_titik", sortable: true },
        { key: "bujur", sortable: true },
        { key: "lintang", sortable: true },
        "Aksi",
      ],
      dataProvinsi: [],
      dataKabupaten: [],
      dataKecamatan: [],
      dataHasilPentek: [],
      dataTtd: [],
      dataTTDDirektur: [],
      dataTTDKetuaTIM: [],
      dataTTDKepalaUPT: [],
      dataTTDPimpinanRapat: [],
      dataPimpinan: [
        {
          value: "ttd_ba_vertek_1",
          text: "Penandatangan 1",
        },
        {
          value: "ttd_ba_vertek_2",
          text: "Penandatangan 2",
        },
        {
          value: "ttd_ba_vertek_3",
          text: "Penandatangan 3",
        },
        {
          value: "ttd_ba_vertek_4",
          text: "Penandatangan 4",
        },
        {
          value: "ttd_ba_vertek_5",
          text: "Penandatangan 5",
        },
      ],
      imageFiles: [],
      optionsPrioritas: [
        { value: true, text: "Ya" },
        { value: false, text: "Tidak" },
      ],
      dataReklamasi: [
        { value: true, text: "Ya" },
        { value: false, text: "Tidak" },
      ],
      selectedFiles: [],
      file_lampiran: null,
      dataKBLI: [],
      dataKlasifikasi: [],
      optionsPerluPNBP: [
        { value: true, text: "Ya" },
        { value: false, text: "Tidak" },
      ],
      status_nomor_oss_error: false,
      nomor_oss_checked: false,
    };
  },
  mounted() {
    this.getKBLI()
    this.getKlasifikasi()
    this.getProvinsi();
    this.getRisiko();
    this.getJenisProyek();
    this.getSkalaUsaha();
    this.getStatusVerdok();
    this.getKordinat();
    this.getHasilPentek();
    // this.getTtd()
    this.loaddata();
  },
  computed: {
    itemsWithNumber() {
      return this.dataKordinat.map((d, index) => ({ ...d, no: index + 1 }));
    },
    rows() {
      return this.dataKordinat.length;
    },
  },
  methods: {
    isValidUrl(urlString) {
      var a = document.createElement("a");
      a.href = urlString;
      return a.host && a.host != window.location.host;
    },
    updateProgress(prevIndex, nextIndex) {
      if (nextIndex >= 0) {
        Vue.set(this, "progress", nextIndex + 1);
      }
    },

    getKBLI() {
      axios.get(this.baseapi + "api/kbli", {
        headers: {
          Authorization: `Bearer ` + this.user.accessToken
        }
      }).then(response => {
        this.dataKBLI = response.data.data;
      }).catch(error => {
        console.log(error)
        return error
      });
    },

    // get klasifikasi
    getKlasifikasi() {
      axios.get(this.baseapi + "api/klasifikasi_pemohon", {
        headers: {
          Authorization: `Bearer ` + this.user.accessToken
        }
      }).then(response => {
        this.dataKlasifikasi = response.data.data;
      }).catch(error => {
        console.log(error)
        return error
      });
    },


    //Upload Lampiran
    async handleFiles(event) {
      // this.selectedFiles = Array.from(event.target.files);
      const file = this.file_lampiran;
      if (!file) return;

      this.$loading(true);
      const formData = new FormData();
      formData.append('file_lampiran_ba', file);

      try {
        const response = await axios.post(this.baseapi + 'api/penambahan_kbli/addLampiranBA/' + this.$route.params.id, formData, {
          headers: {
            Authorization: `Bearer ` + this.user.accessToken,
            'Content-Type': 'multipart/form-data'
          }
        });
        this.$toasted.success("Berhasil Diunggah");
        console.log('Upload success:', response.data);
      } catch (error) {
        this.$toasted.error("Gagal Diunggah");
        console.error('Upload failed:', error);
      } finally {
        this.loaddataLampiran()
        this.$loading(false);
      }
    },

    //Hapus Lampiran
    async hapusFile(namaFile) {
      try {
        const response = await axios.post(this.baseapi + 'api/penambahan_kbli/delLampiranBA/' + this.$route.params.id, {
          lampiran_hapus: namaFile
        }, {
          headers: {
            Authorization: `Bearer ` + this.user.accessToken
          }
        });

        this.$toasted.success("Berhasil Hapus");
      } catch (err) {
        this.$toasted.success("Gagal Hapus");
      } finally {
        this.loaddataLampiran()
      }
    },

    onChangeInputImage(e) {
      const files = [];
      const reader = new FileReader();
      files.push(e.target.files[0]);
      reader.onloadend = () => {
        files[0].preview = reader.result;
        files[0].toUpload = true;
        Vue.set(this, "imageFiles", files);
      };
      reader.readAsDataURL(e.target.files[0]);
    },

    deleteData(id) {
      Swal.fire({
        title: "Hapus Data?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Ya",
      }).then((result) => {
        if (result.isConfirmed) {
          axios
            .delete(this.baseapi + `api/kordinat_penambahan_kbli/` + id, {
              headers: {
                Authorization: `Bearer ` + this.user.accessToken,
              },
            })
            .then((res) => {
              this.$toasted.success("Berhasil Dihapus");
              this.getKordinat();
              return res;
            })
            .catch((err) => {
              console.log(err);
              this.$toasted.error(err.response.data.message);
              return err;
            });
        }
      });
    },

    getHasilPentek() {
      axios
        .get(this.baseapi + "api/hasil_vertek", {
          headers: {
            Authorization: `Bearer ` + this.user.accessToken,
          },
        })
        .then((response) => {
          this.dataHasilPentek = response.data.data;
        })
        .catch((error) => {
          return error;
        });
    },

    getProvinsi() {
      axios
        .get(this.baseapi + "api/provinsi", {
          headers: {
            Authorization: `Bearer ` + this.user.accessToken,
          },
        })
        .then((response) => {
          this.dataProvinsi = response.data.data;
        })
        .catch((error) => {
          return error;
        });
    },

    getTtd() {
      let api;
      // if (this.user.role === 'pic_upt') {
      //     api = 'api/tandatangan?filter=kode_provinsi,=,'+this.dataPermohonan.kode_wilayah_admin
      // } else {
      //     api = 'api/tandatangan'
      // }
      api = "api/tandatangan";
      axios
        .get(this.baseapi + api, {
          headers: {
            Authorization: `Bearer ` + this.user.accessToken,
          },
        })
        .then((response) => {
          this.dataTtd = response.data.data;
          this.dataTtd.map((item) => {
            if (item.role.toLowerCase().includes("direktur")) {
              this.dataTTDDirektur.push(item);
            }
            if (item.role.toLowerCase().includes("ketua_tim")) {
              this.dataTTDKetuaTIM.push(item);
            }
            if (item.role.toLowerCase().includes("kepala_balai")) {
              this.dataTTDKepalaUPT.push(item);
            }

            if (item.role.toLowerCase().includes("pimpinan_pentek_pusat") || item.role.toLowerCase().includes("pimpinan_pentek_upt") || item.role.toLowerCase().includes("ketua_tim")) {
              this.dataTTDPimpinanRapat.push(item);
            }
          });
        })
        .catch((error) => {
          return error;
        });
    },

    getKabupaten(nama) {
      axios
        .get(this.baseapi + "api/kabupaten?filter=nama_provinsi,=," + nama, {
          headers: {
            Authorization: `Bearer ` + this.user.accessToken,
          },
        })
        .then((response) => {
          this.dataKabupaten = response.data.data;
        })
        .catch((error) => {
          return error;
        });
    },

    getKecamatan(nama) {
      axios
        .get(this.baseapi + "api/kecamatan?filter=nama_kabupaten,=," + nama, {
          headers: {
            Authorization: `Bearer ` + this.user.accessToken,
          },
        })
        .then((response) => {
          this.dataKecamatan = response.data.data;
        })
        .catch((error) => {
          return error;
        });
    },

    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },

    changeRadio(field, index) {
      Vue.set(this, field, index);
    },

    getJenisProyek() {
      axios
        .get(this.baseapi + "api/jenis_proyek", {
          headers: {
            Authorization: `Bearer ` + this.user.accessToken,
          },
        })
        .then((response) => {
          this.dataJenisProyek = response.data.data;
        })
        .catch((error) => {
          console.log(error);
          return error;
        });
    },

    getKordinat() {
      axios
        .get(
          this.baseapi +
          "api/kordinat_penambahan_kbli?filter=id_permohonan,=," +
          this.$route.params.id +
          "&sort=id,ASC",
          {
            headers: {
              Authorization: `Bearer ` + this.user.accessToken,
            },
          }
        )
        .then((response) => {
          this.dataKordinat = response.data.data;
        })
        .catch((error) => {
          console.log(error);
          return error;
        });
    },

    getDetailKordinat(id) {
      axios
        .get(this.baseapi + "api/kordinat_penambahan_kbli/" + id, {
          headers: {
            Authorization: `Bearer ` + this.user.accessToken,
          },
        })
        .then((response) => {
          this.detailKordinat = response.data.data;
          this.$bvModal.show("modal-detail-kordinat");
        })
        .catch((error) => {
          console.log(error);
          return error;
        });
    },

    simpanProfil() {
      document.getElementById("next").click();
    },

    nextDokumen() {
      document.getElementById("next").click();
    },

    previousDokumen() {
      document.getElementById("back").click();
    },

    // simpan ba
    hasilVerif() {
      if(this.status_nomor_oss_error){
        return
      }

      this.$validator.validateAll("form-5").then((result) => {
        if (result) {
          console.log("tetst");
          this.$loading(true);
          let formData = new FormData();
          // formData.append('provinsi', this.dataPermohonan.provinsi);
          // formData.append('kabupaten', this.dataPermohonan.kabupaten);
          // formData.append('kecamatan', this.dataPermohonan.kecamatan);
          // formData.append('nama_perairan', this.dataPermohonan.nama_perairan);
          // formData.append('kedalaman', this.dataPermohonan.kedalaman);
          // formData.append('nomor_perda', this.dataPermohonan.nomor_perda);
          // formData.append('tahun_perda', this.dataPermohonan.tahun_perda);
          // formData.append('tentang_perda', this.dataPermohonan.tentang_perda);
          // formData.append('kawasan', this.dataPermohonan.kawasan);
          // formData.append('zona', this.dataPermohonan.zona);
          // formData.append('subzona', this.dataPermohonan.subzona);
          formData.append("hasil_vertek", this.dataPermohonan.hasil_vertek);
          formData.append("nomor_izin_terbit", this.dataPermohonan.nomor_izin_terbit);
          // formData.append("perlu_pnbp", this.dataPermohonan.perlu_pnbp);
          formData.append(
            "ttd_ba_vertek_1",
            this.dataPermohonan.ttd_ba_vertek_1
          );
          formData.append(
            "ttd_ba_vertek_2",
            this.dataPermohonan.ttd_ba_vertek_2
          );
          // formData.append(
          //   "ttd_ba_vertek_3",
          //   this.dataPermohonan.ttd_ba_vertek_3
          // );
          formData.append(
            "ttd_ba_vertek_4",
            this.dataPermohonan.ttd_ba_vertek_4
          );
          // formData.append(
          //   "ttd_ba_vertek_5",
          //   this.dataPermohonan.ttd_ba_vertek_5
          // );

          this.selectedFiles.forEach((file, index) => {
            formData.append('file_lampiran_ba[]', file); // `files[]` untuk banyak file
          });

          // formData.append(
          //   "file_lampiran_ba",
          //   this.dataPermohonan.file_lampiran_ba
          // );
          formData.append(
            "file_lampiran_tambahan",
            this.dataPermohonan.file_lampiran_tambahan
          );
          formData.append("pimpinan_rapat", "ttd_ba_vertek_4");

          if (this.dataPermohonan.hasil_vertek == 'Ditolak') {
            formData.append(
              "alasan_penolakan",
              this.dataPermohonan.alasan_penolakan
            );
          }

          //kosongin catatan direktur
          formData.append(
            "catatan_direktur",
            null
          );

          axios
            .post(
              this.baseapi + "api/penambahan_kbli/generateBAPentek/" + this.$route.params.id,
              formData,
              {
                headers: {
                  "Content-Type": "multipart/form-data",
                  Authorization: `Bearer ` + this.user.accessToken,
                },
              }
            )
            .then((res) => {
              this.$loading(false);
              this.$toasted.success("Berhasil Disimpan");
              document.getElementById("finish").click();
              return res;
            })
            .catch((err) => {
              this.$loading(false);
              console.log(err);
              this.$toasted.error(err.response.data.message);
              // document.getElementById("finish").click();
              return err;
            });
        }
      });
    },

    finishDokumen() {
      document.getElementById("finish").click();
      // console.log(this.$route.params.id)
      // axios
      //     .post(
      //         this.baseapi+'api/penambahan_kbli/'+this.$route.params.id,
      //     {
      //         verifikasi_dokumen_dasar: this.dataPermohonan.verifikasi_dokumen_dasar,
      //         verifikasi_kegiatan_eksisting: this.dataPermohonan.verifikasi_kegiatan_eksisting,
      //         verifikasi_rencana_jadwal: this.dataPermohonan.verifikasi_rencana_jadwal,
      //         verifikasi_rencana_site_plan: this.dataPermohonan.verifikasi_rencana_site_plan,
      //         verifikasi_deskriptif_luasan: this.dataPermohonan.verifikasi_deskriptif_luasan,
      //         verifikasi_peta_lokasi: this.dataPermohonan.verifikasi_peta_lokasi,

      //         verifikasi_magrove: this.dataPermohonan.verifikasi_magrove,
      //         verifikasi_lamun: this.dataPermohonan.verifikasi_lamun,
      //         verifikasi_terumbu_karang: this.dataPermohonan.verifikasi_terumbu_karang,
      //         verifikasi_arus: this.dataPermohonan.verifikasi_arus,
      //         verifikasi_gelombang: this.dataPermohonan.verifikasi_gelombang,
      //         verifikasi_pasang_surut: this.dataPermohonan.verifikasi_pasang_surut,
      //         verifikasi_bathimetri: this.dataPermohonan.verifikasi_bathimetri,
      //         verifikasi_profil_dasar_laut: this.dataPermohonan.verifikasi_profil_dasar_laut,
      //         verifikasi_kondisi_sosial_ekonomi: this.dataPermohonan.verifikasi_kondisi_sosial_ekonomi,
      //         verifikasi_aksesibilitas_lokasi: this.dataPermohonan.verifikasi_aksesibilitas_lokasi,

      //         verifikasi_rencana_pengambilan_sumber_material: this.dataPermohonan.verifikasi_rencana_pengambilan_sumber_material,
      //         verifikasi_rencana_pemanfaatan_lahan_reklamasi: this.dataPermohonan.verifikasi_rencana_pemanfaatan_lahan_reklamasi,
      //         verifikasi_gambaran_umum_reklamasi: this.dataPermohonan.verifikasi_gambaran_umum_reklamasi,
      //         verifikasi_jadwal_rencana_reklamasi: this.dataPermohonan.verifikasi_jadwal_rencana_reklamasi

      //     }
      //     , {
      //         headers: {
      //         Authorization: `Bearer ` + this.user.accessToken
      //         }
      //     })
      //     .then((res) => {
      //     this.$toasted.success("Berhasil Diubah");
      //     document.getElementById("finish").click();
      //     return res;
      //     })
      //     .catch((err) => {
      //     console.log(err)
      //     this.$toasted.error(err.response.data.message);
      //     document.getElementById("finish").click();
      //     return err;
      //     });
    },

    importexcel() {
      this.$validator.validateAll("form-1").then((result) => {
        if (result) {
          this.$loading(true);
          let formData = new FormData();
          formData.append("id_permohonan", this.$route.params.id);
          formData.append("file", this.detailKordinat.file);
          axios
            .post(this.baseapi + "api/kordinat_penambahan_kbli/import", formData, {
              headers: {
                "Content-Type": "multipart/form-data",
                Authorization: `Bearer ` + this.user.accessToken,
              },
            })
            .then((res) => {
              this.$loading(false);
              this.$toasted.success("Berhasil Disimpan");
              this.getKordinat();
              this.detailKordinat = [];
              $(".import").modal("hide");
              return res;
            })
            .catch((err) => {
              this.$loading(false);
              console.log(err);
              this.$toasted.error(err.response.data.message);
              // document.getElementById("finish").click();
              return err;
            });
        }
      });
    },

    getRisiko() {
      axios
        .get(this.baseapi + "api/risiko", {
          headers: {
            Authorization: `Bearer ` + this.user.accessToken,
          },
        })
        .then((response) => {
          this.dataRisiko = response.data.data;
        })
        .catch((error) => {
          console.log(error);
          return error;
        });
    },

    getSkalaUsaha() {
      axios
        .get(this.baseapi + "api/skala_usaha", {
          headers: {
            Authorization: `Bearer ` + this.user.accessToken,
          },
        })
        .then((response) => {
          this.dataSkalaUsaha = response.data.data;
        })
        .catch((error) => {
          console.log(error);
          return error;
        });
    },

    simpanKordinat() {
      this.$validator.validateAll("form-2").then((result) => {
        if (result) {
          axios
            .post(
              this.baseapi + "api/kordinat_penambahan_kbli",
              {
                nama_titik: this.detailKordinat.nama_titik,
                bujur: this.detailKordinat.bujur,
                lintang: this.detailKordinat.lintang,
                id_permohonan: this.$route.params.id,
              },
              {
                headers: {
                  Authorization: `Bearer ` + this.user.accessToken,
                },
              }
            )
            .then((res) => {
              this.$toasted.success("Berhasil Ditambah");
              this.getKordinat();
              this.detailKordinat = [];

              // Wait until the models are updated in the UI
              this.$nextTick(() => {
                this.$bvModal.hide("modal-tambah-kordinat");
              });
              return res;
            })
            .catch((err) => {
              this.$toasted.error(err.response.data.message);
              return err;
            });
        }
      });
    },

    editKordinat() {
      this.$validator.validateAll("form-2").then((result) => {
        if (result) {
          axios
            .put(
              this.baseapi + "api/kordinat_penambahan_kbli/" + this.detailKordinat.id,
              {
                nama_titik: this.detailKordinat.nama_titik,
                bujur: this.detailKordinat.bujur,
                lintang: this.detailKordinat.lintang,
                id_permohonan: this.$route.params.id,
              },
              {
                headers: {
                  Authorization: `Bearer ` + this.user.accessToken,
                },
              }
            )
            .then((res) => {
              this.$toasted.success("Berhasil Diubah");
              this.getKordinat();
              this.detailKordinat = [];

              // Wait until the models are updated in the UI
              this.$nextTick(() => {
                this.$bvModal.hide("modal-detail-kordinat");
              });
              return res;
            })
            .catch((err) => {
              this.$toasted.error(err.response.data.message);
              return err;
            });
        }
      });
    },

    simpanBangunan() {
      let formData = new FormData();
      formData.append(
        "file_rencana_bangunan_dan_instalasi_di_laut",
        this.dataPermohonan.file_2
      );
      // tampak_depan
      axios
        .post(
          this.baseapi + "api/penambahan_kbli/" + this.$route.params.id,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: `Bearer ` + this.user.accessToken,
            },
          }
        )
        .then((response) => {
          this.$toasted.success("Berhasil Diunggah");
          this.loaddata();
          return response;
        })
        .catch((error) => {
          this.$toasted.danger("Gagal Diunggah");
          return error;
        });
    },

    simpanPRL() {
      let formData = new FormData();
      formData.append("file_informasi_prl", this.dataPermohonan.file_3);
      // tampak_depan
      axios
        .post(
          this.baseapi + "api/penambahan_kbli/" + this.$route.params.id,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: `Bearer ` + this.user.accessToken,
            },
          }
        )
        .then((response) => {
          this.$toasted.success("Berhasil Diunggah");
          this.loaddata();
          return response;
        })
        .catch((error) => {
          this.$toasted.danger("Gagal Diunggah");
          return error;
        });
    },

    simpanKondisi() {
      let formData = new FormData();
      formData.append("file_data_kondisi_terkini", this.dataPermohonan.file_4);
      // tampak_depan
      axios
        .post(
          this.baseapi + "api/penambahan_kbli/" + this.$route.params.id,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: `Bearer ` + this.user.accessToken,
            },
          }
        )
        .then((response) => {
          this.$toasted.success("Berhasil Diunggah");
          this.loaddata();
          return response;
        })
        .catch((error) => {
          this.$toasted.danger("Gagal Diunggah");
          return error;
        });
    },

    simpanLain() {
      let formData = new FormData();
      formData.append("file_persyaratan_lain", this.dataPermohonan.file_5);
      // tampak_depan
      axios
        .post(
          this.baseapi + "api/penambahan_kbli/" + this.$route.params.id,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: `Bearer ` + this.user.accessToken,
            },
          }
        )
        .then((response) => {
          this.$toasted.success("Berhasil Diunggah");
          this.loaddata();
          return response;
        })
        .catch((error) => {
          this.$toasted.danger("Gagal Diunggah");
          return error;
        });
    },

    simpanReklamasi() {
      let formData = new FormData();
      formData.append("file_persyaratan_reklamasi", this.dataPermohonan.file_6);
      // tampak_depan
      axios
        .post(
          this.baseapi + "api/penambahan_kbli/" + this.$route.params.id,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: `Bearer ` + this.user.accessToken,
            },
          }
        )
        .then((response) => {
          this.$toasted.success("Berhasil Diunggah");
          this.loaddata();
          return response;
        })
        .catch((error) => {
          this.$toasted.danger("Gagal Diunggah");
          return error;
        });
    },

    loaddata() {
      axios
        .get(this.baseapi + "api/penambahan_kbli/" + this.$route.params.id, {
          headers: {
            Authorization: `Bearer ` + this.user.accessToken,
          },
        })
        .then((response) => {
          this.dataPermohonan = response.data.data;
          this.getTtd();
          this.dataPermohonan["file_1"] = null;
          this.dataPermohonan["file_2"] = null;
          this.dataPermohonan["file_3"] = null;
          this.dataPermohonan["file_4"] = null;
          this.dataPermohonan["file_5"] = null;
          this.dataPermohonan["file_6"] = null;
        })
        .catch((error) => {
          console.log(error);
          return error;
        });
    },

    loaddataLampiran() {
      axios
        .get(this.baseapi + "api/penambahan_kbli/" + this.$route.params.id, {
          headers: {
            Authorization: `Bearer ` + this.user.accessToken,
          },
        })
        .then((response) => {
          this.dataPermohonan.file_lampiran_ba = response.data.data.file_lampiran_ba;
        })
        .catch((error) => {
          console.log(error);
          return error;
        });
    },

    getStatusVerdok() {
      axios
        .get(this.baseapi + "api/status_verdok", {
          headers: {
            Authorization: `Bearer ` + this.user.accessToken,
          },
        })
        .then((response) => {
          this.dataStatusVerdok = response.data.data;
        })
        .catch((error) => {
          console.log(error);
          return error;
        });
    },
    async hapusSemuaKordinat() {
      Swal.fire({
        title: "Hapus Semua Kordinat",
        text: "Apakah Anda yakin ingin menghapus semua kordinat?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Ya, hapus"
      }).then((result) => {
        if (result.isConfirmed) {
          axios
            .delete(this.baseapi + "api/kordinat_penambahan_kbli/permohonan/" + this.$route.params.id, {
              headers: {
                Authorization: `Bearer ` + this.user.accessToken,
              },
            })
            .then((response) => {
              Swal.fire({
                title: "Terhapus",
                text: "Berhasil hapus semua kordinat",
                icon: "success"
              });

              this.getKordinat()
            })
            .catch((error) => {
              console.log(error);
              Swal.fire({
                title: "Gagal hapus",
                text: "Gagal hapus semua kordinat",
                icon: "error"
              });
              return error;
            });
        }
      });

    },

    async checkIzinTerbit() {
      try {
        const url = `${this.baseapi}api/permohonan?filter=nomor_oss,=,${this.dataPermohonan.nomor_izin_terbit}`;

        const response = await axios.get(url, {
          headers: {
            Authorization: `Bearer ${this.user.accessToken}`,
          },
        });

        const data = response?.data?.data;

        this.status_nomor_oss_error = data.length === 0;
        this.nomor_oss_checked = true;

      } catch (error) {
        console.error("checkPermohonanPendahulu error:", error);
        this.status_nomor_oss_error = true;
        this.nomor_oss_checked = true;
      }
    },
  },
};
</script>

<style src="../Wizard.scss" lang="scss" />
<style src="./NotifCustom.scss" lang="scss" />